<template>
  <transition name="fade">
    <div v-if="form" class="card" style="display: flex;justify-content: center">
      <div class="top_button">
        <button @click="$emit('back')">
          <img src="../../../../assets/images/icons/chevron-left-black.svg" alt="">
        </button>
      </div>
      <div class="client">
        <div class="avatar">
          <div class="camera">
            <a class="camera-visible" @click="$refs.avatar.click()">
              <img src="@/assets/images/icons/camera-setting.svg" alt="Изменить">
            </a>
            <img :src="getAvatar()">
            <input hidden type="file" @change="setAvatar" ref="avatar">
          </div>
          <error-text :text="errors.avatar"/>
        </div>
        <div>
          <h4>Имя</h4>
          <input type="text" v-model="form.name">
          <error-text :text="errors.name"/>
        </div>
        <div>
          <h4>Фамилия</h4>
          <input type="text" v-model="form.surname">
          <error-text :text="errors.surname"/>
        </div>
        <div>
          <h4>Телефон</h4>
          <input
           type="text"
           v-model="form.phone"
           v-mask="'+7 (999) 999 99 99'"
          >
          <error-text :text="errors.phone"/>
        </div>
        <div>
          <h4>День рождения</h4>
          <input type="date" v-model="form.date_of_birth">
          <error-text :text="errors.date_of_birth"/>
        </div>
        <div>
          <h4>Заметка</h4>
          <textarea v-model="form.notes" maxlength="120"></textarea>
          <div style="display: flex;">
            <error-text :text="errors.notes"/>
            <small style="display: block; margin-left: auto">{{form != null && form.notes != null ? form.notes.toString().length : '0'}}/120</small>
          </div>
        </div>
        <button-component :loading="loading" variant="filled" @click="create">Сохранить</button-component>
      </div>
    </div>
  </transition>
</template>

<script>
import ButtonComponent from "@/components/ui/buttons/button-component";
import ErrorText from '@/components/ui/text/error-text';

export default {
  name: 'Create',
  components: {ErrorText, ButtonComponent},
  props: {},
  data() {
    return {
      loading: false,
      avatar: null,
      form: null,
      errors: {},
    }
  },
  mounted() {
    this.form = {};
  },
  methods: {
    getAvatar() {
      return this.avatar ? this.avatar : '/default-img-select-light.png';
    },
    setAvatar(event) {
      this.errors.avatar = null;
      let instance = this;
      Array.from(event.target.files).forEach((image) => {
        if (!image.type.match('image.*')) return;
        let reader = new FileReader();
        reader.onload = (() => {
          return (e) => instance.avatar = e.target.result;
        })(image);
        reader.readAsDataURL(image);
        instance.form.avatar = image;
      });
    },
    create() {
      this.loading = true;
      const prevPhone = this.form.phone
      try{
        const phone = parseInt(this.form.phone.replace(/\D+/g,""))
        this.form.phone = `+${phone}`
      } catch (e){
        return this.$set(this.errors, 'phone', ['Заполните это поле'])
      }

      this.$api.master.client.create(this.form).then(({data}) => {
        this.$toast.success('Сохранено!');
        this.$emit('created', data);
      }).catch(({response}) => {
        this.form.phone = prevPhone
        this.errors = response.data.errors;
        this.$toast.error('Проверьте указанные данные!');
      }).finally(() => this.loading = false);
    }
  }
}
</script>

<style scoped lang="scss">
h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  margin: 20px;
}

h4 {
  margin-top: 20px;
  margin-left: 15px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #808080;
}

.card {
  padding: 0;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  height: 100%;

  .client {
    padding: 25px;
    width: 50%;

    input {
      height: 40px;
      width: 100%;
      background-color: #FFFFFF;
      border: 1px solid #DBBFA7;
      box-sizing: border-box;
      border-radius: 5px;
      padding-left: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #383838;
    }
    textarea {
      height: 40px;
      max-width: 100%;
      min-width: 100%;
      background-color: #FFFFFF;
      border: 1px solid #DBBFA7;
      box-sizing: border-box;
      border-radius: 5px;
      padding-left: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #383838;
      max-height: 140px;
      min-height: 40px;
    }

    button {
      margin-top: 45px;
      height: 50px;
      width: 100%;
      background: #DBBFA7;
      border: none;
      border-radius: 5px;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #383838;
    }

    .avatar {
      width: 100%;
      display: flex;
      justify-content: center;
    }

  }

  .story {
    width: 50%;
    border-left: 1px solid #E5E5E5;

    a {
      text-decoration: none;

      &:active {
        color: unset;
      }

      &:focus {
        .price {
          img {
            transform: rotate(180deg);
            transition: 0.4s;
          }
        }
      }
    }

    .item {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E5E5E5;

      .title {
        margin: 20px 25px 15px 20px;

        .name {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: #383838;
        }

        .date {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: #808080;
        }
      }

      .price {
        margin: 20px 25px 15px 20px;
        display: flex;
        align-items: center;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #383838;
      }


    }
  }
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  .camera {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    &:hover .camera-visible {
      visibility: visible;
    }

    .camera-visible {
      visibility: hidden;
      position: absolute;
      background: rgba(56, 56, 56, 0.70);
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      img {
        width: 37.95px;
        height: 30.8px;
        border-radius: unset;
      }
    }
  }

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
  }
}

input:disabled {
  background-color: #dbbfa7 !important;
  position: relative;
  background-image: url("/lock-solid.svg") !important;
  background-repeat: no-repeat !important;
  background-position: bottom 12px right 10px;
  background-size: 12px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
.top_button {
  display: none;
}

@media screen and (max-width: 1170px) {
  .top_button {
    display: block;
    width: 100%;
    padding: 20px 40px 0 40px;
    button {
      background-color: transparent;
      border: none;
    }
  }
  .card .client {
    width: 100%;
    padding: 25px 40px;
  }
  .card .client button {
    max-width: 100%;
  }
}
</style>
